export function makeFormulasCustom(data){
  let customAttributesValues = [];
  for(let i = 0; i < data.length; i++){
    if(data[i].content.checked == 1){
      customAttributesValues.push(data[i].id)
    }
  }
  console.log(customAttributesValues);
  return customAttributesValues;
}
